import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHero = styled.div`
  background-image: linear-gradient(
    180deg,
    ${color('navy_900')},
    ${color('navy_800')}
  );

  @media (min-width: ${screen('md')}) {
    background-image: url('${getPublicPath('/images/comparison/hero.svg')}'),
      linear-gradient(180deg, ${color('navy_900')}, ${color('navy_800')});
    background-repeat: no-repeat;
    background-position: top right, top left;
    background-size: contain, cover;
  }

  @media (min-width: ${screen('xl')}) {
    background-image: url('${getPublicPath('/images/comparison/hero-xl.svg')}'),
      linear-gradient(180deg, ${color('navy_900')}, ${color('navy_800')});
    background-position: top left calc(50% + 350px), top left;
    background-size: contain, cover;
  }
`;

export const StyledWrapper = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
`;

export const StyledContainer = styled.div`
  padding: 0 ${spacing('md')} ${spacing('xl2')};
  max-width: ${container('sm')};
  color: ${color('text_white')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    padding: ${spacing('xl4')} ${spacing('md')} ${spacing('xl5')};
  }
`;
